module.exports = __webpack_public_path__ + "img/train-intro4.aed07ef0.jpg";